(function(){
  'use strict';
  var UPSELL_HANDLES = ['bruges-6-pack-best-sellers-variety','bruges-6-pack-fall-variety','bruges-6-pack-classics-torpedo-variety','noes-waffle-bundle'];

  var drawer = document.querySelector('[data-bcd]');
  var backdrop = document.querySelector('[data-bcd-backdrop]');
  if (!drawer) return;

  var DISCOUNT_PCT = parseFloat(drawer.dataset.discountPct) || 0;
  var DISCOUNT_MULT = (100 - DISCOUNT_PCT) / 100;
  var BUNDLE_DISCOUNT_PCT = parseFloat(drawer.dataset.bundleDiscountPct) || 20;
  var BUNDLE_DISCOUNT_MULT = (100 - BUNDLE_DISCOUNT_PCT) / 100;
  var SUBSCRIPTION_DISCOUNT_PCT = parseFloat(drawer.dataset.subscriptionDiscountPct) || 25;
  var SUBSCRIPTION_DISCOUNT_MULT = (100 - SUBSCRIPTION_DISCOUNT_PCT) / 100;

  // Hidden discount code that gives 15% off loose boxes whenever a bundle is
  // anywhere in the cart. Applied/removed automatically below — never shown
  // to the customer as a code field. This exists because Shopify's native
  // Buy X Get Y discount can't combine with another product discount on a
  // non-Plus plan, so a bundle's own 20% off was blocking that mechanism
  // entirely. A plain discount code doesn't carry that restriction.
  var BOX_BONUS_CODE = 'BB-EXTRA15-QW7X2K';
  var BOX_BONUS_PCT = 15;
  var BOX_BONUS_MULT = (100 - BOX_BONUS_PCT) / 100;
  var boxBonusSyncInFlight = false;

  // Box-quantity tier ladder: 2 boxes = 10% off, 3 boxes = 10% off + free shipping,
  // 4 boxes = 15% off + free shipping. Mirrors the automatic Shopify discounts
  // "Bruges Box Tiers — 10% off (2+ boxes)" / "— 15% off (4+ boxes)" / "— Free Shipping (3+ boxes)".
  var BOX_TIERS = [
    { qty: 2, pct: 10, freeShip: false },
    { qty: 3, pct: 10, freeShip: true },
    { qty: 4, pct: 15, freeShip: true }
  ];

  // A single "three box bundle" unit is three boxes bundled together, so it counts
  // as 3 boxes toward the tier ladder above — not 1, and not 0.
  var BUNDLE_BOX_EQUIVALENT = 3;

  function isBundleProduct(titleOrHandle){
    if (!titleOrHandle) return false;
    return titleOrHandle.toString().toLowerCase().indexOf('bundle') !== -1;
  }

  function tierEligibleQty(cart){
    // Bundles carry their own dedicated 20%-off + free-shipping deal (see
    // BUNDLE_DISCOUNT_PCT) and are never folded into the box-tier ladder —
    // they already beat anything the ladder unlocks, so counting them here
    // used to produce nonsense messaging like "add 1 more for free shipping"
    // when a bundle (which already has free shipping) was the only thing in cart.
    var n = 0;
    cart.items.forEach(function(item){
      if (item.selling_plan_allocation) return;
      if (isBundleProduct(item.handle) || isBundleProduct(item.product_title)) return;
      n += item.quantity;
    });
    return n;
  }

  function cartHasBundle(cart){
    return cart.items.some(function(item){
      return isBundleProduct(item.handle) || isBundleProduct(item.product_title);
    });
  }

  // --- Bundle Box Bonus: auto-apply/remove the hidden discount code -------
  // Whenever a bundle is anywhere in the cart, the hidden BOX_BONUS_CODE
  // should be applied (giving 15% off loose Waffle/Crème de Miel boxes).
  // Whenever no bundle is present, it should be removed. Any OTHER discount
  // codes already on the cart (e.g. a customer-entered code) are preserved.
  function hasBoxBonusApplied(cart){
    return (cart.discount_codes || []).some(function(d){ return d.code === BOX_BONUS_CODE; });
  }

  function syncBoxBonusDiscount(cart){
    if (boxBonusSyncInFlight) return;
    var shouldApply = cartHasBundle(cart);
    var isApplied = hasBoxBonusApplied(cart);
    if (shouldApply === isApplied) return;

    var existingCodes = (cart.discount_codes || []).map(function(d){ return d.code; });
    var nextCodes;
    if (shouldApply) {
      nextCodes = existingCodes.indexOf(BOX_BONUS_CODE) === -1 ? existingCodes.concat([BOX_BONUS_CODE]) : existingCodes;
    } else {
      nextCodes = existingCodes.filter(function(c){ return c !== BOX_BONUS_CODE; });
    }

    boxBonusSyncInFlight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({ discount: nextCodes.join(',') })
    }).then(function(r){ return r.json(); }).then(function(updatedCart){
      boxBonusSyncInFlight = false;
      renderCart(updatedCart);
    }).catch(function(){ boxBonusSyncInFlight = false; });
  }

  function tierProgress(qty, hasBundle){
    if (hasBundle) {
      // A bundle already guarantees 20% off + free shipping, and the hidden
      // Bundle Box Bonus discount gives every loose box 15% off immediately —
      // there's no tier to climb here, it's binary: bundle present = maxed out.
      if (qty <= 0) {
        return { msg: '🎉 Your bundle includes 20% off + free shipping — add any box for 15% off it too!', pct: 100, unlocked: true };
      }
      return { msg: '🎉 20% off your bundle + 15% off every extra box, free shipping included!', pct: 100, unlocked: true };
    }
    if (qty <= 0) {
      return { msg: 'Add 2 boxes and save 10% — stacks up to 15% off + free shipping', pct: 0, unlocked: false };
    }
    if (qty === 1) {
      return { msg: 'Add 1 more box for 10% off', pct: 25, unlocked: false };
    }
    if (qty === 2) {
      return { msg: '10% off unlocked — add 1 more box for free shipping too', pct: 50, unlocked: true };
    }
    if (qty === 3) {
      return { msg: 'Add 1 more box for 15% off + free shipping', pct: 75, unlocked: true };
    }
    return { msg: "🎉 15% off + free shipping unlocked!", pct: 100, unlocked: true };
  }

  // Returns the box-tier discount % a cart with this many eligible boxes qualifies for.
  // Used to project what an upsell item WOULD cost if added right now, so the cart
  // drawer upsell cards can show a slashed price that matches the tier the customer
  // is about to unlock (or is already in).
  function discountPctForBoxQty(qty){
    var pct = 0;
    BOX_TIERS.forEach(function(t){ if (qty >= t.qty) pct = t.pct; });
    return pct;
  }

  function isSkipped(el){
    while (el && el !== document) {
      if (el.getAttribute && el.getAttribute('data-bcd-skip') === '1') return true;
      el = el.parentNode;
    }
    return false;
  }

  function markBrugesPdpAsSkip(){
    var pdpForm = document.getElementById('pdp-form');
    if (pdpForm) pdpForm.setAttribute('data-bcd-skip', '1');
    var pdpBtn = document.getElementById('pdpAtcBtn');
    if (pdpBtn) pdpBtn.setAttribute('data-bcd-skip', '1');
  }
  markBrugesPdpAsSkip();
  if (document.readyState !== 'complete') {
    window.addEventListener('load', markBrugesPdpAsSkip);
  }
  document.addEventListener('shopify:section:load', markBrugesPdpAsSkip);

  var els = {
    count: drawer.querySelector('[data-bcd-count]'),
    shipping: drawer.querySelector('[data-bcd-shipping]'),
    shippingMsg: drawer.querySelector('[data-bcd-shipping-msg]'),
    bar: drawer.querySelector('[data-bcd-bar]'),
    empty: drawer.querySelector('[data-bcd-empty]'),
    items: drawer.querySelector('[data-bcd-items]'),
    upsell: drawer.querySelector('[data-bcd-upsell]'),
    upsellTrack: drawer.querySelector('[data-bcd-upsell-track]'),
    foot: drawer.querySelector('[data-bcd-foot]'),
    subtotal: drawer.querySelector('[data-bcd-subtotal]'),
    subtotalStrike: drawer.querySelector('[data-bcd-subtotal-strike]'),
    checkoutAmount: drawer.querySelector('[data-bcd-checkout-amount]')
  };

  function fmt(cents){ return '$' + (cents/100).toFixed(2); }

  function calculateLineDisplay(item){
    if (item.selling_plan_allocation) {
      var compareAtPerUnit = item.selling_plan_allocation.compare_at_price;
      if (compareAtPerUnit && compareAtPerUnit > 0) {
        var lineCompareAt = compareAtPerUnit * item.quantity;
        if (lineCompareAt > item.final_line_price) {
          return { price: item.final_line_price, strike: lineCompareAt };
        }
      }
      if (SUBSCRIPTION_DISCOUNT_PCT > 0) {
        return {
          price: Math.ceil(item.original_line_price * SUBSCRIPTION_DISCOUNT_MULT),
          strike: item.original_line_price
        };
      }
    }
    if (item.original_line_price > item.final_line_price) {
      return { price: item.final_line_price, strike: item.original_line_price };
    }
    var isBundle = isBundleProduct(item.handle) || isBundleProduct(item.product_title);
    var pct = isBundle ? BUNDLE_DISCOUNT_PCT : DISCOUNT_PCT;
    var mult = isBundle ? BUNDLE_DISCOUNT_MULT : DISCOUNT_MULT;
    if (pct > 0) {
      return {
        price: Math.ceil(item.original_line_price * mult),
        strike: item.original_line_price
      };
    }
    return { price: item.final_line_price, strike: null };
  }

  function openDrawer(){
    drawer.hidden = false;
    backdrop.hidden = false;
    requestAnimationFrame(function(){
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer(){
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    setTimeout(function(){
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 350);
    document.documentElement.style.overflow = '';
  }

  function renderItem(item){
    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
    if (item.selling_plan_allocation) {
      var plan = item.selling_plan_allocation.selling_plan;
      if (plan && plan.name) meta.push('Subscription: ' + plan.name);
    }
    var metaHtml = meta.length ? '<p class="bcd-item-meta">' + meta.join(' · ') + '</p>' : '';

    var disp = calculateLineDisplay(item);
    var priceHtml = '<span class="bcd-item-price">' + fmt(disp.price) + '</span>';
    if (disp.strike && disp.strike > disp.price) {
      priceHtml = '<span class="bcd-item-strike">' + fmt(disp.strike) + '</span>' + priceHtml;
    }

    return '<div class="bcd-item" data-key="' + item.key + '">' +
      '<img src="' + (item.image || '') + '" alt="' + (item.product_title || '') + '" loading="lazy">' +
      '<div class="bcd-item-info">' +
        '<h4>' + item.product_title + '</h4>' +
        metaHtml +
        '<div class="bcd-item-bottom">' +
          '<div class="bcd-qty">' +
            '<button type="button" data-bcd-qty="-1" aria-label="Decrease">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-bcd-qty="+1" aria-label="Increase">+</button>' +
          '</div>' +
          '<div>' + priceHtml + '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="bcd-remove" data-bcd-remove aria-label="Remove">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>' +
      '</button>' +
    '</div>';
  }

  function renderCart(cart){
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    syncBoxBonusDiscount(cart);
    var count = cart.item_count || 0;
    els.count.textContent = count;
    var tierQty = tierEligibleQty(cart);
    var hasBundle = cartHasBundle(cart);
    var tier = tierProgress(tierQty, hasBundle);
    els.bar.style.width = tier.pct + '%';
    els.shippingMsg.textContent = tier.msg;
    if (tier.unlocked) {
      els.shipping.classList.add('is-unlocked');
    } else {
      els.shipping.classList.remove('is-unlocked');
    }
    if (count === 0) {
      els.empty.hidden = false;
      els.items.hidden = true;
      els.items.innerHTML = '';
      els.foot.hidden = true;
      els.upsell.hidden = true;
    } else {
      els.empty.hidden = true;
      els.items.hidden = false;
      els.items.innerHTML = cart.items.map(renderItem).join('');
      els.foot.hidden = false;
      var effectiveTotal = 0;
      var effectiveOriginal = 0;
      cart.items.forEach(function(item){
        var disp = calculateLineDisplay(item);
        effectiveTotal += disp.price;
        effectiveOriginal += disp.strike || disp.price;
      });
      els.subtotal.textContent = fmt(effectiveTotal);
      els.checkoutAmount.textContent = fmt(effectiveTotal);
      if (effectiveOriginal > effectiveTotal) {
        els.subtotalStrike.textContent = fmt(effectiveOriginal);
        els.subtotalStrike.hidden = false;
      } else {
        els.subtotalStrike.hidden = true;
      }
      loadUpsell(cart);
    }
  }

  function loadUpsell(cart){
    var inCart = cart.items.map(function(i){ return i.handle; });
    var picks = UPSELL_HANDLES.filter(function(h){ return inCart.indexOf(h) === -1; }).slice(0, 3);
    if (picks.length === 0) { els.upsell.hidden = true; return; }
    var currentBoxQty = tierEligibleQty(cart);
    Promise.all(picks.map(function(h){
      return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){return null;});
    })).then(function(prods){
      var valid = prods.filter(function(p){ return p && p.available; });
      if (valid.length === 0) { els.upsell.hidden = true; return; }
      els.upsell.hidden = false;
      els.upsellTrack.innerHTML = valid.map(function(p){
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var isBundle = isBundleProduct(p.handle) || isBundleProduct(p.title);
        var pctForThisProduct, multForThisProduct;
        if (isBundle) {
          // Bundles keep their own dedicated backend discount — separate from the
          // box-tier ladder by design (see bruges-shopify-editor workflow rules).
          pctForThisProduct = BUNDLE_DISCOUNT_PCT;
          multForThisProduct = BUNDLE_DISCOUNT_MULT;
        } else if (cartHasBundle(cart)) {
          // A bundle is already in the cart, so the hidden Bundle Box Bonus
          // discount will give this box 15% off the moment it's added —
          // regardless of quantity tiers, which don't apply alongside a bundle.
          pctForThisProduct = BOX_BONUS_PCT;
          multForThisProduct = BOX_BONUS_MULT;
        } else {
          // Regular single-box upsells: project the box-tier discount the customer
          // would actually receive if this box were added to the cart right now,
          // so the slashed price always matches the live tier (2/3/4 boxes).
          var boxEquivalent = 1;
          var projectedBoxQty = currentBoxQty + boxEquivalent;
          pctForThisProduct = discountPctForBoxQty(projectedBoxQty);
          multForThisProduct = (100 - pctForThisProduct) / 100;
        }
        var priceBlock = '<div class="bcd-upsell-price">' + fmt(p.price) + '</div>';
        if (pctForThisProduct > 0) {
          var discountedPrice = Math.ceil(p.price * multForThisProduct);
          priceBlock = '<div class="bcd-upsell-price"><span class="bcd-upsell-price-now">' + fmt(discountedPrice) + '</span> <span class="bcd-upsell-price-strike">' + fmt(p.price) + '</span></div>';
        }
        return '<div class="bcd-upsell-card">' +
          '<img src="' + img + '" alt="' + p.title + '">' +
          '<div>' +
            '<h4>' + p.title.replace('Bruges 6-Pack: ','').replace(' Liège Waffle','') + '</h4>' +
            priceBlock +
            '<button type="button" class="bcd-upsell-add" data-bcd-add-upsell="' + p.variants[0].id + '">Add</button>' +
          '</div>' +
        '</div>';
      }).join('');
    });
  }

  function fetchCart(){
    return fetch('/cart.js', {headers:{Accept:'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); return cart; });
  }

  function changeItem(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({id:key, quantity:quantity})
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  function addItem(formDataOrParams){
    var body, headers;
    if (formDataOrParams instanceof FormData) {
      body = formDataOrParams;
      headers = {Accept:'application/json'};
    } else {
      body = JSON.stringify(formDataOrParams);
      headers = {'Content-Type':'application/json',Accept:'application/json'};
    }
    return fetch('/cart/add.js', {method:'POST', body:body, headers:headers})
      .then(function(r){ return r.json(); })
      .then(function(){ return fetchCart(); })
      .then(function(){ openDrawer(); });
  }

  function ensureSellingPlan(form, fd){
    var doc = document;
    var activeOpt = doc.querySelector('.bruges-pdp .pdp-option.active');
    if (!activeOpt) return fd;
    if (activeOpt.dataset.opt === 'subscribe') {
      var planFromInput = (form.querySelector('#sellingPlan') || {}).value || '';
      var planFromGlobal = window.BRUGES_SUB_PLAN_ID || '';
      var planId = planFromInput || planFromGlobal;
      if (planId) {
        fd.set('selling_plan', String(planId));
      }
    } else {
      fd.delete('selling_plan');
    }
    return fd;
  }

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"], form#pdp-form, form.pdp-form');
    if (!form) return;
    if (form.id === 'pdp-form') return;
    if (isSkipped(form) || isSkipped(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var fd = ensureSellingPlan(form, new FormData(form));
    addItem(fd);
  }, true);

  document.addEventListener('click', function(e){
    var atcBtn = e.target.closest('.pdp-atc, button[type="submit"][name="add"]');
    if (!atcBtn) return;
    if (atcBtn.id === 'pdpAtcBtn') return;
    if (isSkipped(atcBtn)) return;
    var form = atcBtn.closest('form[action*="/cart/add"], form#pdp-form, form.pdp-form');
    if (!form) return;
    if (form.id === 'pdp-form') return;
    if (isSkipped(form)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var fd = ensureSellingPlan(form, new FormData(form));
    addItem(fd);
  }, true);

  document.addEventListener('click', function(e){
    var cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"], [data-bcd-open], .cart-link, .cart-icon, .header__cart, [data-cart-drawer-toggle]');
    if (cartLink && !e.target.closest('[data-bcd]')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      fetchCart().then(openDrawer);
      return false;
    }
  }, true);

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-bcd-close]') || e.target.matches('[data-bcd-backdrop]')) {
      closeDrawer();
      return;
    }
    var qtyBtn = e.target.closest('[data-bcd-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('.bcd-item');
      var key = item.dataset.key;
      var current = parseInt(item.querySelector('.bcd-qty span').textContent, 10) || 1;
      var delta = parseInt(qtyBtn.dataset.bcdQty, 10);
      var newQty = Math.max(0, current + delta);
      changeItem(key, newQty);
      return;
    }
    var rmBtn = e.target.closest('[data-bcd-remove]');
    if (rmBtn) {
      var item = rmBtn.closest('.bcd-item');
      changeItem(item.dataset.key, 0);
      return;
    }
    var upBtn = e.target.closest('[data-bcd-add-upsell]');
    if (upBtn) {
      var vid = upBtn.dataset.bcdAddUpsell;
      addItem({id: parseInt(vid, 10), quantity: 1});
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  fetchCart();

  window.BrugesCart = { open: function(){ fetchCart().then(openDrawer); }, close: closeDrawer, refresh: fetchCart };
})();
